var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IDEs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.539999962
  }, /*#__PURE__*/React.createElement("g", {
    id: "p5js-IDE-styles-foundation-pt-2",
    transform: "translate(-496.000000, -1165.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow-shape-copy",
    transform: "translate(501.000000, 1172.198314) rotate(90.000000) translate(-501.000000, -1172.198314) ",
    points: "502.4 1169.39663 508 1174.99663 506.6 1176.39663 501 1170.79663 495.4 1176.39663 494 1174.99663 499.6 1169.39663 500.996628 1168"
  })))));
};
export default SvgRightArrow;